import React from 'react'
import ClientLayout from '../layout/ClientLayout'

function ClientDashboardPage() {
  return (
    <ClientLayout>
      <div>ClientDashboardPage</div>
    </ClientLayout>
  )
}

export default ClientDashboardPage